export const editorPath = (foiId, categoryId) => `/foi/${foiId}/category/${categoryId}/redactions`
export const viewerPath = (foiId, categoryId, fileId) => `/foi/${foiId}/category/${categoryId}/files/${fileId}`
export const backToRequestUrl = (foiId, categoryId) => `/foi/${foiId}?tab=deduplicationAndRedaction&categoryId=${categoryId}`
